/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFlagUs(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={18}
      fill='none'
      viewBox='0 0 24 18'
      {...props}
    >
      <path
        fill='#B41F30'
        d='M24 1a1 1 0 00-1-1H10v10H0v7a1 1 0 001 1h22a1 1 0 001-1V1z'
      />
      <path
        fill='#fff'
        d='M10 2h14v2H10zM10 6h14v2H10zM0 10v2h24v-2H0zM0 14h24v2H0z'
      />
      <path fill='#00256A' d='M10 10H0V1a1 1 0 011-1h9v10z' />
      <path
        fill='#fff'
        d='M5 3.961l-.316.684h-.752l.55.57-.203.824L5 5.63l.722.409-.203-.824.55-.57h-.753L5 3.961zM2.553 1.514l-.316.685h-.752l.55.57-.203.823.721-.409.722.41-.203-.825.55-.57h-.753l-.316-.683zM7.446 1.514l.316.685h.752l-.549.57.203.823-.722-.409-.722.41.204-.825-.55-.57h.753l.315-.683zM2.553 8.486L2.237 7.8h-.752l.55-.57-.203-.824.721.41.722-.41-.203.824.55.57h-.753l-.316.684zM7.446 8.486l.316-.685h.752l-.549-.57.203-.824-.722.41-.722-.41.204.824-.55.57h.753l.315.684z'
      />
    </svg>
  );
}

export default SvgFlagUs;
